import { render } from "./insure-special-agreement.vue?vue&type=template&id=2da090ea&scoped=true"
import script from "./insure-special-agreement.vue?vue&type=script&lang=js"
export * from "./insure-special-agreement.vue?vue&type=script&lang=js"

import "./insure-special-agreement.vue?vue&type=style&index=0&id=2da090ea&lang=stylus&scoped=true"

import exportComponent from "D:\\Repository\\Zidan\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2da090ea"]])

export default __exports__